module.exports = __webpack_public_path__ + "img/green1_sl.5784a4f6.svg";